/**
 * 目录的英文映射
 */
export const categoryCnMap = {
  'best-practice': '最佳实践',
  'engineering-culture': '工程师文化',
  'guides-and-tutorials': '指南和教程',
  'news': '新闻',
  'operations-and-observability': '运维与监控',
  'user-stories': '用户故事',
  'meetup': '社区活动',
}
